export const Common_en = {
  ID_COMMON_CONFIRM: "Confirm",
};
